export const dependenceFrag = `
    id
    from
    state
    dependence {
      degree
    }
`;
